import React from "react";

import { IUserDrivingPermit } from "Bands/types";
import { TeaserProps } from "shared/components";
import { DocumentTeaser } from "./DocumentTeaser";

interface Props extends IUserDrivingPermit, TeaserProps {}

export const DrivingPermitTeaser: React.FC<Props> = ({ ...rest }) => {
  return <DocumentTeaser {...rest} />;
};
